/**
 *
 * Tabs
 *
 */
/* eslint-disable */
(function () {
	const mxTabsGroup = document.querySelectorAll('.tabs');

	if (mxTabsGroup) {

		const tabHash  = window.location.hash.substr(1);

		mxTabsGroup.forEach((tabInstance) => {
			const tabs = Array.from(tabInstance.querySelectorAll('.tabs__links .tabs__link'));
			const panes = Array.from(tabInstance.querySelectorAll('.tabs__panel'))

			/* handle click */
			const handleClick = (e, pane) => {

				e.preventDefault();

				tabs.forEach(node => {
					node.classList.remove('active');
				});

				e.currentTarget.classList.add('active');
				panes.forEach((x) => x.classList.remove('active'));
				pane.classList.add('active');
			};

			const handleHashChange = () => {
				let newTabHash = window.location.hash.substr(1);

				/**check if hash var exists exists */
				if (newTabHash != '') {

					/**match hash to id of button & get index */
					tabs.forEach((node, i) => {

						/**find matching index item for pane */
						if(newTabHash == node.id) {

							/**hide all active classes for buttons */
							tabs.forEach(node => {
								node.classList.remove('active');
							});

							/* add active class to indexed tab */
							tabs[i].classList.add('active');

							/**hide all active classes for panes */
							panes.forEach((x) => x.classList.remove('active'));

							/* add active class to indexed pane */
							panes[i].classList.add('active');

							/* scroll the correct pane into view */
							panes[i].parentNode.parentNode.parentNode.scrollIntoView({
								behavior: "smooth"
							});
							return;
						}
					});
					/* if tabHash doesn't exist, fall back to selecting the first tab */
				} else {
					tabs.forEach(node => {
						node.classList.remove('active');
					});
					if(tabs.length > 1) {
						tabs[0].classList.add('active');
						panes.forEach((x) => x.classList.remove('active'));
						panes[0].classList.add('active');
					}
				}
			}

			/* handle url hash scroll to and select */
			window.addEventListener('load', () =>  {
				handleHashChange();
			});

			/* handle hashchange on same url */
			window.addEventListener('hashchange', (event) => {
				console.log('hash changed');
				handleHashChange();
			});

			/* listen for clicks */
			tabs.forEach((node, i) => {
				node.addEventListener('click', (e) => handleClick(e, panes[i]));
			});
		});
	}
})();
/* eslint-enable */
